<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
  <section class="box">
    <div class="tile-progress bg-white text-left">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <label>Select Customer Account</label>
          <ng-select   [items]="accounts"
            (change)="getServiceWorkFlowByAccountId();getPaymentConfig();getSubscriptionType(accountId)"
            name="accounts" bindLabel="accountName" [clearable]="true" [searchable]="true" bindValue="accountId"
            [(ngModel)]="accountId">
          </ng-select>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 " *ngIf="accountId!=null && accountId>0" >
          <label>Subscription Type</label>
          <br>
          <!--<div style="float:left"><label  style="color:green">Post-Paid</label></div>-->
          <div style="float:left;margin-right:5px;">
            <!--<p-inputSwitch [(ngModel)]="prepaidStatus" (onChange)="showStatus('prepaid')"></p-inputSwitch>-->
            <label class="switch">
              <input type="checkbox" [(ngModel)]="prepaidStatus" (click)="changeAccountSubscriptionType()">
              <!--<span class="slider"></span>-->
              <div class="slider">
                <!--ADDED HTML --><span class="on" style="color:white;font-size: 14px;">Prepaid</span><span class="off"
                  style="color:white;font-size: 14px;">Postpaid</span>
                <!--END-->
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="content-body" *ngIf="accountId!=null && accountId>0">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngIf="showRefractionModule==true">
          <div class="panel panel-primary">
            <div class="panel-heading text-center" style="padding:15px;height:50px">
              Refraction
            </div>
            <div class="panel-body">
              <div style="height:450px">
                <table>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Objective Refraction</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Subjective Refraction</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Prescription </td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-close" style="color:red"></span></td>
                    <td style="padding:10px">AV call with Optometrist</td>
                  </tr>
                </table>
              </div>
              <div style="margin-left:30px">
                <div style="float:left;padding-top:5px;"><span class="fa fa-inr"></span></div>
                <div style="float:left;padding-left: 10px"><input type="number" min="0"
                  onkeypress="return /[0-9 ]/i.test(event.key)" onselectstart="return false" onpaste="return false;" required
                    [(ngModel)]="paymentConfig.refraction" class="form-control" style="width:150px;font-weight: bold"
                    style="float:left;width:150px;font-weight: bold"
                    onkeydown="return (event.keyCode!=189 && event.keyCode!=109 && event.keyCode!=107 && event.keyCode!=187 && event.keyCode!=69);">
                  </div>
                <div style="float:left;padding-top:5px;padding-left: 10px"><span>per unit</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngIf="showRefractionModule==true">
          <div class="panel panel-primary">
            <div class="panel-heading text-center" style="padding:15px;height:50px">
              Tele Refraction
            </div>
            <div class="panel-body">
              <div style="height:450px">
                <table>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Objective Refraction</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Subjective Refraction</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Prescription</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">AV call with Optometrist</td>
                  </tr>
                </table>
              </div>
              <div style="margin-left:30px">
                <div style="float:left;padding-top:5px;"><span class="fa fa-inr"></span></div>
                <div style="float:left;padding-left: 10px"><input type="number" min="0" class="form-control" 
                  onkeypress="return /[0-9 ]/i.test(event.key)" onselectstart="return false" onpaste="return false;" required
                    [(ngModel)]="paymentConfig.teleRefraction" style="width:150px;font-weight: bold"
                    style="float:left;width:150px;font-weight: bold"
                    onkeydown="return (event.keyCode!=189 && event.keyCode!=109 && event.keyCode!=107 && event.keyCode!=187 && event.keyCode!=69);">
                  </div>
                <div style="float:left;padding-top:5px;padding-left: 10px"><span>per unit</span></div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngIf="showReferralModule==true">
          <div class="panel panel-primary">
            <div class="panel-heading text-center" style="padding:15px;height:50px">
              Referral
            </div>
            <div class="panel-body">
              <div style="height:450px">
                <table>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Tetiary Hospital Referral</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Referral Report Generation</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Referral doctor follow-up</td>
                  </tr>
                </table>
              </div>
              <div style="margin-left:30px">
                <div style="float:left;padding-top:5px;"><span class="fa fa-inr"></span></div>
                <div style="float:left;padding-left: 10px"><input type="number" min="0" required
                    [(ngModel)]="paymentConfig.referral" class="form-control" style="width:150px;font-weight: bold"
                    style="float:left;width:150px;font-weight: bold"></div>
                <div style="float:left;padding-top:5px;padding-left: 10px"><span>per unit</span></div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngIf="showFundusModule==true">
          <div class="panel panel-primary">
            <div class="panel-heading text-center" style="padding:15px;height:50px">
              Fundus Examination
            </div>
            <div class="panel-body">
              <div style="height:450px">
                <table>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Fundus Imaging</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">AI Assist (AI For Grading)</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">AI Assist (AI For Diagnosis)</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Expert Report Generation (With SLA)</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Expert Report Generation (Without SLA)</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Rejected Fundus</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">QA failed cases</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-close" style="color:red"></span></td>
                    <td style="padding:10px">AI Autonomous mode</td>
                  </tr>
                </table>
              </div>
              <div style="margin-left:30px">
                <div style="float:left;padding-top:5px;"><span class="fa fa-inr"></span></div>
                <div style="float:left;padding-left: 10px"><input type="number" min="0" 
                  onkeypress="return /[0-9 ]/i.test(event.key)" onselectstart="return false" onpaste="return false;" required
                    [(ngModel)]="paymentConfig.fundus" class="form-control" style="width:150px;font-weight: bold"
                    style="float:left;width:150px;font-weight: bold" 
                    onkeydown="return (event.keyCode!=189 && event.keyCode!=109 && event.keyCode!=107 && event.keyCode!=187 && event.keyCode!=69);">
                  </div>
                <div style="float:left;padding-top:5px;padding-left: 10px"><span>per unit</span></div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngIf="showFundusModule==true" style="display:none">
          <div class="panel panel-primary">
            <div class="panel-heading text-center" style="padding:15px">FUNDUS EXAMINATION(Autonomous)</div>
            <div class="panel-body">
              <div style="height:450px">
                <table>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Fundus Imaging</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">AI assist (AI For Grading)</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">AI assist (AI For Diagnosis)</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Expert Report Generation (With SLA)</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Expert Report Generation (Without SLA)</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Rejected Fundus</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">QA Failed Case</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">AI autonomous result with report</td>
                  </tr>
                </table>
              </div>
              <div style="margin-left:30px">
                <div style="float:left;padding-top:5px;"><span class="fa fa-inr"></span></div>
                <div style="float:left;padding-left: 10px"><input type="number" min="0" class="form-control" 
                  onkeypress="return /[0-9 ]/i.test(event.key)" onselectstart="return false" onpaste="return false;" required
                    [(ngModel)]="paymentConfig.fundusAutonomous" style="width:150px;font-weight: bold"
                    style="float:left;width:150px;font-weight: bold"
                    onkeydown="return (event.keyCode!=189 && event.keyCode!=109 && event.keyCode!=107 && event.keyCode!=187 && event.keyCode!=69);">
                  </div>
                <div style="float:left;padding-top:5px;padding-left: 10px"><span>per unit</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngIf="showSpectacleModule==true" style="display:none">
          <div class="panel panel-primary">
            <div class="panel-heading text-center" style="padding:15px;height:50px">
              SPECTACLE (Basic Package)
            </div>

            <div class="panel-body">
              <div style="height:455px">
                <table>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">E-cart and Inventory Management</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Spectacle with SLA</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Spectacle without SLA</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Spectacle Order status update</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Replacement Under Warranty</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Repair After Replacement</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-close" style="color:red"></span></td>
                    <td style="padding:10px">Order Workflow</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-close" style="color:red"></span></td>
                    <td style="padding:10px">3D head measurement</td>
                  </tr>
                </table>
              </div>
              <div style="margin-left:30px">
                <div style="float:left;padding-top:5px;"><span class="fa fa-inr"></span></div>
                <div style="float:left;padding-left: 10px"><input type="number" min="0" 
                  onkeypress="return /[0-9 ]/i.test(event.key)" onselectstart="return false" onpaste="return false;" required
                    [(ngModel)]="paymentConfig.spectacleBasic" class="form-control"
                    style="width:150px;font-weight: bold" style="float:left;width:150px;font-weight: bold"
                    onkeydown="return (event.keyCode!=189 && event.keyCode!=109 && event.keyCode!=107 && event.keyCode!=187 && event.keyCode!=69);">
                  </div>
                <div style="float:left;padding-top:5px;padding-left: 10px"><span>per unit</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngIf="showSpectacleModule==true" style="display:none">
          <div class="panel panel-primary">
            <div class="panel-heading text-center" style="padding:15px">
              SPECTACLE (Advanced)</div>
            <div class="panel-body">
              <div style="height:450px">
                <table>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">E-cart and Inventory Management</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Spectacle with SLA</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Spectacle without SLA</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Spectacle Order status update</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Replacement Under Warranty</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Repair After Replacement</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">Order Workflow</td>
                  </tr>
                  <tr>
                    <td style="padding:10px"><span class="fa fa-check" style="color:green"></span></td>
                    <td style="padding:10px">3D head measurement</td>
                  </tr>
                </table>
              </div>
              <div style="margin-left:30px">
                <div style="float:left;padding-top:5px;"><span class="fa fa-inr"></span></div>
                <div style="float:left;padding-left: 10px"><input type="number" min="0" class="form-control" 
                  onkeypress="return /[0-9 ]/i.test(event.key)" onselectstart="return false" onpaste="return false;" required
                    [(ngModel)]="paymentConfig.spectacleAdvanced" style="width:150px;font-weight: bold"
                    style="float:left;width:150px;font-weight: bold"
                    onkeydown="return (event.keyCode!=189 && event.keyCode!=109 && event.keyCode!=107 && event.keyCode!=187 && event.keyCode!=69);">
                  </div>
                <div style="float:left;padding-top:5px;padding-left: 10px"><span>per unit</span></div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 text-center">
          <button class="btn btn-sm " style="height:38px;color:white;background-color: rgb(87,200,231);font-size: 14px;" (click)="savePaymentConfig()">
            <i class="fa fa-fw fa-lg fa-check-circle"></i>
            Update Unit Pricing</button>
        </div>
      </div>
      <!-- <div class="col-xs-12 text-center">
       
      </div> -->
    </div>
  </section>
</div>